import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ExpiredItems from './components/ExpiredItems';

const expiredItems = (props,{ t }) => (
  <Container>
    <ExpiredItems {...props} />
  </Container>
);

expiredItems.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(expiredItems);
